/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { useParams } from 'react-router-dom'
import { useLocation } from "react-router";
import EditClientTabs from './EditClientTabs';

const EditClient: React.FC = () => {

  const param = useParams();
  const data: any = useLocation();
  const {id} = param;
  return (
   
        <EditClientTabs clientId={id} clientData={data.state.clientData} />
  )
}

export default EditClient